import { Link } from 'react-router-dom';
import Logo from '@/components/core/Logo';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-of-service-page">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 h-14 flex items-center">
          <Logo />
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl font-[500] tracking-tight mb-8">Terms of Service</h1>
        <p className="font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground mb-8">
          Last updated: February 2026
        </p>

        <div className="prose prose-neutral max-w-none space-y-8">
          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">1. Acceptance of Terms</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              By accessing or using Atlas, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">2. Description of Service</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              Atlas is an AI-powered knowledge mapping platform that allows users to create, explore, and learn from interactive mind maps. Our service includes AI-generated content, explanations, quizzes, and collaboration features.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">3. User Accounts</h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-4">
              To use certain features of Atlas, you must create an account. You agree to:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-body text-muted-foreground">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">4. Subscription and Payments</h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-4">
              Atlas offers both free and paid subscription plans:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-body text-muted-foreground">
              <li><strong>Free Plan:</strong> Limited to 10 credits, 1 AI-generated map, and 3 total maps</li>
              <li><strong>Pro Plan:</strong> Unlimited access to all features for $15/month</li>
            </ul>
            <p className="font-body text-muted-foreground leading-relaxed mt-4">
              Subscriptions are billed monthly and can be cancelled at any time. Upon cancellation, you will retain access until the end of your billing period.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">5. User Content</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              You retain ownership of all content you create on Atlas. By using our service, you grant us a license to store, display, and process your content solely for the purpose of providing our services to you.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">6. Acceptable Use</h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-4">
              You agree not to use Atlas to:
            </p>
            <ul className="list-disc pl-6 space-y-2 font-body text-muted-foreground">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Transmit harmful, offensive, or illegal content</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the service</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">7. AI-Generated Content</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              Atlas uses artificial intelligence to generate content. While we strive for accuracy, AI-generated content may contain errors or inaccuracies. Users should verify important information from authoritative sources.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">8. Limitation of Liability</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              Atlas is provided "as is" without warranties of any kind. We shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the service.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">9. Changes to Terms</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              We may update these terms from time to time. We will notify users of significant changes via email or through the service. Continued use of Atlas after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-[500] mb-4">10. Contact</h2>
            <p className="font-body text-muted-foreground leading-relaxed">
              For questions about these Terms of Service, please contact us at legal@atlas.app
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <Link to="/" className="font-body text-sm text-cobalt hover:underline">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
